import React from "react";
import OutroBlock from "./content/OutroBlock";
import { ReactComponent as CurveSecondary } from "../../assets/curve-secondary.svg";

export default function Outro() {
  return (
    <section className="position-relative bg-secondary-light" style={{ backgroundColor: "#ffffe9", marginBlockEnd: "-50px", paddingBlockEnd: "50px" }}>
      <CurveSecondary className={`fold-bottom-curve`} style={{ bottom: "99%", color: "#ffffe9" }} />

      <div className="container pb-4" style={{ marginBlockStart: "6%" }}>
        <div className="row pb-4">
          <OutroBlock />
        </div>
      </div>
    </section>
  );
}
